export default {
  resultCode: 0,
  message: {
    title: "success",
  },
  status: "200",
  result: "OK",
  data: {
    setMenuDefaultItemList: [
            {
              setMenuIdx : 1,
              name: "마르게리따 피자",
              price: 0,
              qty: 1,
              selectYn : false,
            },
            {
              setMenuIdx : 1,
              name: "파스타",
              price: 0,
              qty: 1,
              selectYn : true,
            },
            {
              setMenuIdx : 1,
              name: "음료",
              price: 0,
              qty: 1,
              selectYn : true,
            }
        ]
    }
}